import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import { getFeatured, getHot, getLatest } from "@/lib/catalog";
import { TYPE_LABELS } from "@/types/movie";

export default function Home() {
  useDocumentMeta(
    "亚洲视频一区－免费高清影视视频在线播放平台",
    "亚洲视频一区提供丰富多样的影视内容，包括电影、电视剧和综艺节目。用户可浏览最新影视资源，满足在线观看需求，体验优质视频服务。",
    "亚洲视频一区,视频影视,在线影视,电影观看,电视剧播放,高清影视,在线视频,影视资源"
  );

  const featured = getFeatured();
  const hot = getHot(10);
  const latest = getLatest(6);

  return (
    <div className="pb-4">
      <HeroCarousel items={featured} />

      <CategoryQuickLinks />

      <section className="w-full px-4 md:px-8 lg:px-12 mt-12 md:mt-16">
        <SectionHeading
          icon="ri-fire-line"
          title="热门影视推荐"
          subtitle="根据全站播放热度为你精选"
          moreTo="/category/movie"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
          {hot.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 mt-12 md:mt-16">
        <SectionHeading
          icon="ri-time-line"
          title="最新更新"
          subtitle="按更新时间排序的最新影视资源"
          moreTo="/category/tv"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {latest.map((movie) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex gap-4 rounded-lg overflow-hidden bg-background-100 border border-background-300/50 hover:border-primary-500/60 transition-all duration-300 p-3"
            >
              <div className="relative w-28 md:w-32 shrink-0 aspect-[5/7] rounded-md overflow-hidden bg-background-200">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} 海报`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded bg-accent-500 text-background-950 text-[11px] font-heading font-bold">
                  {movie.rating.toFixed(1)}
                </span>
              </div>
              <div className="flex-1 min-w-0 py-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                    {movie.title}
                  </h3>
                  <span className="shrink-0 text-[10px] px-1.5 py-0.5 rounded bg-secondary-500/15 text-secondary-500 font-label">
                    {TYPE_LABELS[movie.type]}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-600">
                  {movie.year} · {movie.region} · {movie.genres.join(" / ")}
                </p>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 md:line-clamp-3">
                  {movie.summary}
                </p>
                <p className="mt-2 flex items-center gap-1 text-[11px] text-foreground-500">
                  <i className="ri-refresh-line text-primary-500" />
                  更新于 {movie.updatedAt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 mt-12 md:mt-16">
        <div className="relative rounded-lg overflow-hidden border border-background-300/50 bg-background-100">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 via-background-100 to-secondary-950/50" />
          <div className="relative px-5 md:px-10 py-8 md:py-12 flex flex-col md:flex-row md:items-center gap-6 justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
                免费高清，随时随地畅快观看
              </h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                亚洲视频一区汇聚电影、电视剧与综艺节目等丰富影视资源，界面清晰、筛选便捷。登录无需注册，输入关键词即可找到你想看的内容。
              </p>
            </div>
            <div className="flex flex-wrap gap-3 shrink-0">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-film-line text-lg" />
                浏览电影频道
              </Link>
              <Link
                to="/category/variety"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-200/80 text-foreground-900 text-sm font-semibold hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                看综艺
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}